import { Tooltip } from 'uikit/tooltips/default'
import { Flex } from 'uikit/layout/default'
import type { BusinessEntityType, NodeMetadata } from '../../types'
import { isUrl } from '../../utils/utils'
import styles from '../controls.module.scss'
import { PropertyField } from './property-field'
import { NODE_METADATA_SECTIONS, getMetadataEntries } from './metadata-formatters'

const metadataTooltipStyles = { root: { maxWidth: 400 } }

interface MetadataValueProps {
  value: string
}

function MetadataValue({ value }: MetadataValueProps) {
  const isLink = isUrl(value)
  return (
    <Tooltip title={value} placement='left' styles={metadataTooltipStyles}>
      {isLink ? (
        <a href={value} target='_blank' rel='noopener noreferrer' className={styles.metadataLink}>
          {value}
        </a>
      ) : (
        <span className={styles.metadataValue}>{value}</span>
      )}
    </Tooltip>
  )
}

interface NodeMetadataSectionProps {
  nodeType: BusinessEntityType
  metadata?: NodeMetadata
}

export function NodeMetadataSection({ nodeType, metadata }: NodeMetadataSectionProps) {
  const config = NODE_METADATA_SECTIONS[nodeType]
  if (!config || !metadata) return null

  const entries = getMetadataEntries(metadata, config.entries)
  if (entries.length === 0) return null

  return (
    <PropertyField label={config.label}>
      <Flex className={styles.metadataContainer}>
        {entries.map(({ key, label, displayValue }) => (
          <Flex key={key} className={styles.metadataRow}>
            <span className={styles.metadataKey}>{label}</span>
            <MetadataValue value={displayValue} />
          </Flex>
        ))}
      </Flex>
    </PropertyField>
  )
}
